/**
 * Opcje
 *
 * @export
 * @enum {number}
 */
export enum Options {
  TERM_PASSED = 'TERM_PASSED',
  DICTIONARY = 'DICTIONARY',
  SCHEMA_ID = 'SCHEMA_ID',
  VALIDATE_ATTACHMENTS = 'VALIDATE_ATTACHMENTS',
  VIEWS = 'VIEWS'
}
